import React, { useEffect } from "react";
import { Box, Grid, Typography, Card, CardContent } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { fetchMyPromotions } from "../../store/Slices/promotionSlice";

import PromoteForm from "./components/PromoteForm";
import MySubmissions from "./components/MySubmissions";
import HeroBanner from "./components/HeroBanner";
import PlatformBadges from "./components/PlatformBadges";

export default function PromoteEarnPage() {
  const dispatch = useDispatch();
  const theme = useTheme();

  useEffect(() => {
    dispatch(fetchMyPromotions());
  }, [dispatch]);

  return (
    <Box
      sx={{
        bgcolor: theme.palette.background.default,
        color: theme.palette.text.primary,
        minHeight: "100vh",
      }}
    >
      <Box sx={{ p: { xs: 1.5, md: 2 }, maxWidth: 1280, mx: "auto" }}>
        <HeroBanner />
        <PlatformBadges />

        {/* Guide section */}
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: 6,
            mb: 2,
            bgcolor: "background.paper",
          }}
        >
          <CardContent>
            <Typography
              variant="h6"
              fontWeight={700}
              color="text.primary"
              gutterBottom
            >
              How it works
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography variant="body2" color="text.secondary">
                1) Create a short video about one topic: Deposit, Withdrawal,
                Security & Support, AI Trading, or General.
              </Typography>
              <Typography variant="body2" color="text.secondary">
                2) Publish on YouTube, Instagram, or TikTok with the required
                hashtags (English hashtags).
              </Typography>
              <Typography variant="body2" color="text.secondary">
                3) Submit your link and upload a screenshot here.
              </Typography>
              <Typography variant="body2" color="text.secondary">
                4) Our support team will review your submission. If approved,
                2&nbsp;USDT will be added to your Spot wallet (cooldown rules
                apply).
              </Typography>
            </Box>
          </CardContent>
        </Card>

        <Grid container spacing={2}>
          <Grid item xs={12} md={5}>
            <PromoteForm />
          </Grid>
          <Grid item xs={12} md={7}>
            <MySubmissions />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
